import React, { useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    top: theme.spacing(9),
  },
}));

const NotifyContext = React.createContext(null);

export const useNotifyContext = () => {
  const context = React.useContext(NotifyContext);
  if (context === undefined) {
    throw new Error("useNotifyContext must be used within NotifyProvider");
  }

  return context;
};

const Notify = (props) => {
  const { t } = useTranslation();
  const { notify, setNotify } = props;
  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotify({
      ...notify,
      isOpen: false,
    });
  };

  return (
    <Snackbar
      className={classes.root}
      open={notify.isOpen}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <Alert severity={notify.type} onClose={handleClose}>
        {t(notify.message)}
      </Alert>
    </Snackbar>
  );
};

Notify.propTypes = {
  notify: PropTypes.object,
  setNotify: PropTypes.func,
};

export const NotifyProvider = ({ children }) => {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  return (
    <NotifyContext.Provider value={setNotify}>
      {children}
      <Notify notify={notify} setNotify={setNotify} />
    </NotifyContext.Provider>
  );
};
NotifyProvider.propTypes = {
  children: PropTypes.object,
};

export default Notify;
